import type { LocaleMessageBundle } from '../../types'

export const paymentMethodMessages: LocaleMessageBundle = {
  vi: {
    'paymentMethod.model': 'phương thức thanh toán',
    'paymentMethod.fields.code': 'Mã phương thức',
    'paymentMethod.fields.name': 'Tên phương thức',
    'paymentMethod.fields.icon': 'Icon',
    'paymentMethod.fields.sortOrder': 'Thứ tự',
    'paymentMethod.fields.status': 'Trạng thái',
    'paymentMethod.fields.note': 'Ghi chú',
    'paymentMethod.fields.system': 'Hệ thống',
    'paymentMethod.placeholders.code': 'vd: cash, e_wallet',
    'paymentMethod.placeholders.name': 'Nhập tên phương thức',
    'paymentMethod.placeholders.icon': 'mdi-cash',
    'paymentMethod.placeholders.note': 'Ghi chú',
    'paymentMethod.actions.create': 'Thêm phương thức thanh toán',
    'paymentMethod.actions.update': 'Cập nhật phương thức thanh toán',
    'paymentMethod.actions.cancel': 'Đóng',
    'paymentMethod.dialog.createSubtitle': 'Thêm phương thức dùng trên khung bán hàng',
    'paymentMethod.dialog.updateSubtitle': 'Chỉnh sửa thông tin phương thức thanh toán',
    'paymentMethod.deleteConfirm': 'Xóa phương thức "{name}"?',
    'paymentMethod.help.system': 'Phương thức hệ thống không thể xóa hoặc đổi mã',
    'paymentMethod.validation.duplicateName': 'Tên phương thức thanh toán đã tồn tại',
    'paymentMethod.errors.saveFailed': 'Không thể lưu phương thức thanh toán',
  },
  en: {
    'paymentMethod.model': 'payment method',
    'paymentMethod.fields.code': 'Code',
    'paymentMethod.fields.name': 'Name',
    'paymentMethod.fields.icon': 'Icon',
    'paymentMethod.fields.sortOrder': 'Sort order',
    'paymentMethod.fields.status': 'Status',
    'paymentMethod.fields.note': 'Note',
    'paymentMethod.fields.system': 'System',
    'paymentMethod.placeholders.code': 'e.g. cash, e_wallet',
    'paymentMethod.placeholders.name': 'Enter method name',
    'paymentMethod.placeholders.icon': 'mdi-cash',
    'paymentMethod.placeholders.note': 'Note',
    'paymentMethod.actions.create': 'Add payment method',
    'paymentMethod.actions.update': 'Update payment method',
    'paymentMethod.actions.cancel': 'Cancel',
    'paymentMethod.dialog.createSubtitle': 'Add a method used on the sales screen',
    'paymentMethod.dialog.updateSubtitle': 'Edit payment method details',
    'paymentMethod.deleteConfirm': 'Delete payment method "{name}"?',
    'paymentMethod.help.system': 'System methods cannot be deleted or have their code changed',
    'paymentMethod.validation.duplicateName': 'Payment method name already exists',
    'paymentMethod.errors.saveFailed': 'Failed to save payment method',
  },
}
